import React from 'react';
// Init Configuration
import { get } from '../../Storage';
import Cashout from '../../Widget/Cashout';
import { ClassName } from 'mgToolsKit';
import PropTypes from 'prop-types';
var AppSettings = get();
var componentName = AppSettings.appId + 'TicketComponent';
var styles = AppSettings.styles;

class Ticket extends React.Component {
    constructor(props) {
        super(props);       
        this.state = {
            cashout: null,
            proactiveCashoutData: props.proactiveCashoutData,
            showCashoutResult: false, 
        }
        this.configuration = props.data.configuration;   
        this.timeoutId = null; // per il polling del cashout proattivo     
    }

    componentDidUpdate(prevProps) {
        if (prevProps.proactiveCashoutData !== this.props.proactiveCashoutData ) {
            this.setState({ proactiveCashoutData: this.props.proactiveCashoutData });
        }
    }

    componentWillUnmount(){
        if(this.timeoutId){
            clearTimeout(this.timeoutId);
        }
    }

    //Eventi 
    viewTicket(link, event){
        window.open(link, "_blank");
    }

    //apertura del link di condivisione 
    shareTicket(ticket){
       //se siamo nel modulo
        if (typeof _moduloScommesseInstance != "undefined") {
            let request = {
                id: ticket.ticketId,
                ib: ticket.authorityId,
                terrestrial: ticket.isTerrestrial,
                isFreebet: ticket.isFreebet
            }

            _moduloScommesseInstance.showModalForTicket (request);
        }else{
            let link = "/scommesse-sportive-mobile?shareTicket="+ ticket.ticketId + "|"+ ticket.authorityId +'|' + ticket.isTerrestrial;
            window.open(link, "_blank");
        }   
    }

    renderTicket() { 
        let {ticket, colCanaleEnabled} = this.props;  
        let key = "ticket-"+ ticket.betId;
        let keyDetails = "ticket_details-"+ key;
        let subClassName = [];

        let parzializzazione = ticket.byProposal && ticket.isReply && ticket.isPartialAmount;
        let freebet = "";
        let cashoutTab = "";
        let cashoutResult =  "";
        let cashout = this.props.data.cashout;

        let risk = ticket.risk;
        //tipo di ticket 
        let type = "Standard";
        if(ticket.isSystem){
            type = "Sistema";
        }

        let htmlAmount =  
                        <li onClick={this.viewTicket.bind(this, ticket.link)} className='mg-ticket-amount'>
                            <span className='mg-ticket-type-label'>Giocata</span>
                            <span className="mg-info-amount"  title="Importo giocato">{ticket.amount}</span>
                        </li>;

        let htmlRisk =
                    <li onClick={this.viewTicket.bind(this, ticket.link)} className='mg-ticket-risk'> 
                        <span className='mg-ticket-type-label'>Vincita</span>
                        <span>{risk}</span>
                    </li>;
         
        let className = ["mg-bet-" + ticket.status];
        let descrizione = "";        
        if(!ticket.isProposal){

            switch (ticket.status) {
                case 'opened':
                    descrizione = <span className='text-label'>in corso</span>;
                    break;
                case 'losing':
                    descrizione = <span className='text-label'>persa</span>;
                    break;
                case 'winning':
                    descrizione = <span className='text-label'>vinta</span>;
                    break;
                case 'cancelled':
                    className.push("mg-bet-losing");
                    descrizione = <span className='text-label'>annullata</span>;
                    break;
                        
            }

            // gestione delle varie tipologie
            if(ticket.byProposal){
                className.push("bet-byproposal");
            }

            if(ticket.isTerrestrial){
                className.push("mg-bet-online");
                className.push("mg-bet-agenzia");
            }
            else{
                className.push("mg-bet-online");

                if(ticket.isFreebet){
                    className.push("mg-bet-freebet");
                    freebet = <span className="userBoxTicket--freebet" href="#"></span>;
                }
            }


            if(parzializzazione){
                className.push("bet-by-partial");

                let titleInitialAmount = "Importo piazzato dall'utente "+ ticket.initialAmount + ", importo accettato " + ticket.amount +" biglietto venduto automaticamete a " + ticket.amount;
                let titlelAmount = "Importo accettato";
                htmlAmount =   
                            <li onClick={this.viewTicket.bind(this, ticket.link)} className='mg-ticket-amount'>
                                <span className='mg-ticket-type-label'>Giocata</span>
                                <span className="mg-info-amount mg-variazione-importo" title={titleInitialAmount}>{ticket.initialAmount}</span>
                                <span className="mg-info-amount" title={titlelAmount}>{ticket.amount}</span>
                            </li>;
            }

            if(ticket.byCashout){
                className.push("winning-bet-cashout");
                descrizione = <span className='text-label'>vinta con Cashout</span>;

                let titleInitialAmount = "Vincita iniziale del ticket " + ticket.initialAmount + ", Vincita cashout accettata dall'utente " + ticket.risk;
                let titlelAmount = "Importo cashout";
                
                htmlRisk =   
                        <li className='mg-ticket-risk'>
                            <span className='mg-ticket-type-label'>Vincita</span>
                            <span className="mg-info-amount mg-variazione-importo" title={titleInitialAmount}>{ticket.initialAmount}</span>
                            {/* <span className="mg-info-amount" title={titlelAmount}>{ticket.risk}</span> */}
                            <span className="bs-ticket-info-value bs-cashout" title={titlelAmount}>
                                <span className="bs-cashout-label">Cashout</span>
                                <span className="bs-cashout-value">{ticket.risk}</span>
                                <i></i>
                            </span>
                        </li>;
            }
          
            if(this.configuration.cashoutEnabled){
                if (ticket.status == 'opened'
                    && !ticket.isTerrestrial
                    && !ticket.isFreebet
                    && !ticket.isProposal
                    && !ticket.isSystem) {
                    subClassName.push('mg-ticket-cashout');
                    let keycashout = "cashout_ticket" + ticket.betId;

                    if (this.configuration.cashoutProattivoEnabled && this.state.proactiveCashoutData === undefined) {
                        cashoutTab = "";
                    } else {
                        let id = this.configuration.cashoutProattivoEnabled ? this.state.proactiveCashoutData.ticketId : ticket.betId;
                        cashoutTab =(
                            <li id={id} className={`mg-ticket-cashout-btn ${this.configuration.cashoutProattivoEnabled ? "proactive-cashout-container" : ""}`}>
                                <Cashout 
                                    type="button"
                                    onClick={this.askCashout.bind(this)} 
                                    key={keycashout} 
                                    configuration={this.configuration}
                                    data={ticket}
                                    proactiveCashoutData={this.state.proactiveCashoutData}
                                />
                            </li>);
                    }
                }
                   

                if(cashout != null){
                    let hideCta = false;
                    if (cashout.ticketId == ticket.betId) {
                        if (cashout.errors.length > 0) {
                            if (this.configuration.cashoutProattivoEnabled) {
                                hideCta = true;
                            }
                            cashoutResult =
                                <li className={`mg-ticket-cashout-error ${this.configuration.cashoutProattivoEnabled ? "feedback-proactive-cashout" : ""}`}>
                                    <Cashout
                                        type="error"
                                        key={key + '_casherror'}
                                        configuration={this.configuration}
                                        data={cashout}
                                        hideCta={hideCta}
                                    />
                                </li>;
 
                        } else {
                            //ask successo 
                            if (cashout.ask) {
                                if (this.configuration.cashoutProattivoEnabled) {
                                    hideCta = true;
                                }
                                cashoutResult =
                                    <li className={`mg-ticket-cashout-success ${this.configuration.cashoutProattivoEnabled ? "feedback-proactive-cashout" : ""}`}>
                                        <Cashout
                                            type="confirm"
                                            key={key + '_cashask'}
                                            data={cashout}
                                            configuration={this.configuration}
                                            onClick={this.doCashout.bind(this)}
                                             hideCta={hideCta}
                                            />
                                    </li>;

                            }
                            if (cashout.do) {
                                if (this.configuration.cashoutProattivoEnabled) {
                                    hideCta = true;
                                }
                                cashoutResult =
                                    <li className={`mg-ticket-cashout-success ${this.configuration.cashoutProattivoEnabled ? "feedback-proactive-cashout" : ""}`}>
                                        <Cashout
                                            type="success"
                                            key={key + '_cashask'}
                                            data={cashout}
                                            configuration={this.configuration}
                                            onClick={this.doCashout.bind(this)}
                                            hideCta={hideCta} 
                                            />
                                    </li>;

                                if (this.timeoutId === null) {
                                    this.timeoutId = setTimeout(() => {
                                        this.props.refreshData(this);

                                    }, 30000);
                                }

                            }
                        }
                    }
                }
            }
      
        }else{                    
            className.push("mg-bet-online");
            className.push("mg-bet-proposal");

            switch (ticket.status) {
                case 'opened':
                    descrizione = <span className='text-label'>In valutazione</span>
                    break;
                case 'cancelled':
                    className.push("mg-bet-losing");
                    descrizione = <span className='text-label'>Non accettata</span>;
                    break;               
            }
        }
    
        let share = false;
        if(!ticket.isProposal){
            share = true;
        }
        
        return( 
                <ul key={key} className={ClassName(className)}>
                    {/* intestazione  */}
                    <li className={"userBoxTicket--heading"}>
                        <h3 className={"userBoxTicket--status"} href="#">{descrizione}
                            {freebet}
                        </h3>
                        {colCanaleEnabled ?
                                            <a className="mg-bet-canale mg-icona-canale">
                                            <i className="mg-icona-canale" aria-hidden="true"></i>
                                        </a>
                        : null}

                        {share ?
                            <a className="btn-share-ticket" title="Condividi il ticket" onClick={this.shareTicket.bind(this, ticket)} href="#">
                                <i className="fa-mg fa-mg-share" aria-hidden="true"></i>
                            </a>
                        : null
                        }                        
                                     
                        
                        <a className="btn-view-ticket" title="visualizza il ticket" onClick={this.viewTicket.bind(this, ticket.link)} href="#">
                            <i className="fa-mg fa-mg-receipt" aria-hidden="true"></i>
                        </a>
                    </li>
                    {/* dettagli ticket  */}
                    <li className="userBoxTicket--dettagli">
                        <ul key={keyDetails} className={ClassName(subClassName)}>
                            <li onClick={this.viewTicket.bind(this, ticket.link)} className='mg-ticket-type'>
                                <span className='mg-ticket-type-label'>Tipo</span>
                                <span>{type}</span>
                            </li>
                            {htmlAmount}
                            {htmlRisk}
                            {cashoutTab}
                            {cashoutResult}
                        </ul>
                    </li>	
                </ul>);
    }

     //#region Cashout 
    
    askCashout(response){
        this.context.askCashout(response);
    }

    doCashout(response){
        this.context.doCashout(response);
    }
    
    //#endregion

    render(){
       return this.renderTicket();
    }


}

Ticket.displayName = componentName;

Ticket.propTypes = {
};

Ticket.contextTypes = {
    doCashout: PropTypes.func,
    askCashout: PropTypes.func
}

// default props
Ticket.defaultProps = {
};

export default Ticket;